import { retrieveUserSession } from '@/utils/browserStorage';

/** @todo: Improve this */
export const isAuthenticatedAsCorporate = () => {
  const userSession = retrieveUserSession();

  return userSession?.isCorporate;
};
